export const patientFactors = [
  'Medical history',
  'Weight trajectory',
  'Metabolic health',
  'Existing conditions',
  'Treatment preferences',
  'Individual goals',
  'Follow-up requirements',
];

export const beforeItems = [
  'You spend valuable time searching for the right reference before a consultation.',
  'You repeatedly review the same topics because your information is scattered across different sources.',
  'You want a more consistent structure for organizing obesity assessments.',
  'You need a clearer way to review comorbidities and relevant patient characteristics.',
  'You want to organize treatment discussions without starting from scratch every time.',
  'You find it difficult to keep track of follow-up considerations and outstanding questions.',
];

export const afterItems = [
  'Organize the major stages of adult obesity care.',
  'Navigate relevant clinical topics through a visual framework.',
  'Structure the information you need to review before and during consultations.',
  'Organize treatment considerations using dedicated worksheets.',
  'Document outstanding questions and references requiring verification.',
  'Prepare more consistent follow-up reviews.',
];

export const painPoints = [
  {
    title: 'You spend too much time preparing for obesity consultations.',
    body: 'You know the information is available, but finding and organizing the relevant material takes time.',
  },
  {
    title: 'You want a more systematic assessment process.',
    body: 'You need a practical framework for organizing patient history, weight-related information, existing conditions, and other relevant clinical factors.',
  },
  {
    title: 'You want a clearer way to organize treatment reviews.',
    body: 'You need a structured method for documenting treatment considerations, patient preferences, relevant risks, and questions requiring further evaluation.',
  },
  {
    title: 'You need to organize obesity-related comorbidities.',
    body: 'You want a dedicated place to organize cardiovascular, metabolic, respiratory, and other relevant health considerations.',
  },
  {
    title: 'You want more consistent follow-up documentation.',
    body: 'You need a practical way to record outstanding questions, monitoring considerations, and topics to revisit during future consultations.',
  },
  {
    title: "You're tired of creating your own resources from scratch.",
    body: 'You would rather work with a structured collection of professional templates than repeatedly rebuild your notes and checklists.',
  },
];

export const guaranteeSteps = [
  'Explore all six volumes.',
  'Review the five specialized tools.',
  'Examine the worksheets and checklists.',
  'Assess the visual navigation framework.',
  'Decide whether the organization suits your needs.',
];
